/*eslint-disable*/
import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Pagination,
    PaginationItem,
    PaginationLink,
    Col
} from "reactstrap";

// core components

function CustomPagination({ array, setPage, itemsPerPage }) {
    // Array that stores the number of pages [1,2,3,4...]
    const [pages, setPages] = useState([])
    useEffect(() => {
        let items = []
        if (array.length <= itemsPerPage) {
            setPages([1])
            return
        }
        for (let i = 0; i < (array.length / itemsPerPage); i++) {
            items.push(i + 1)
        }
        setPages(items)
    }, [array.length])

    return (
        <Pagination>
            {
                pages.map((i) =>
                    <PaginationItem key={i}>
                        <PaginationLink
                            onClick={(e) => {
                                e.preventDefault()
                                setPage(i)
                            }}
                            href={`page#${i}`}
                        >
                            {i}
                        </PaginationLink>
                    </PaginationItem>
                )
            }
        </Pagination>
    )
}

export default CustomPagination;
